export default __webpack_public_path__ + "static/media/cross-dnd-icon.ef606b49.svg";